import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";
import CustomStore from 'devextreme/data/custom_store';
import {ToastsManager} from "ng2-toastr";

@Component({
  selector: 'app-payorder',
  templateUrl: './payorder.component.html',
  styleUrls: ['./payorder.component.scss']
})
export class PayorderComponent implements OnInit {

  dataSource: any = {};
  public password: any;

  constructor(public editDataService: EditDataService
    , public toastr: ToastsManager
    , public vRef: ViewContainerRef) {

    this.toastr.setRootViewContainerRef(vRef);
    this.password = this.editDataService.password;
    this.dataSource.store = this.getPayordersStore(this.editDataService, this.toastr);
  }

  customizeColumns(columns) {
    columns[0].width = 140;
    columns[2].width = 140;
    columns[2].alignment = "center";
  }



  /**
   * Для подсчёта высоты грида на ходу
   * @returns {string}
   */
  countHeight() {
    return 420 + "%";
  }

  onCellPrepared(e) {
    if (e.rowType === "data") {
    /*  if (e.column.command === "edit") {*/

        let isEditing = e.row.isEditing,
        $links = e.cellElement.find(".dx-link");
        $links.text("");

        if (isEditing) {
          $links.filter(".dx-link-save").addClass("dx-icon-save");
          $links.filter(".dx-link-cancel").addClass("dx-icon-revert");
        } else {
          $links.filter(".dx-link-download").addClass("dx-icon-download");
          $links.filter(".dx-link-edit").addClass("dx-icon-edit");
          $links.filter(".dx-link-delete").addClass("dx-icon-trash");
        }
      /*} else {

        let isEditing = e.row.isEditing,
        $links = e.cellElement.find(".dx-link");

        $links.filter(".dx-link-save").addClass("dx-icon-save");
      }*/
    }
  }

  ngOnInit() {
  }

  getPayordersStore(editDataService, toastr) {
    return new CustomStore({

      load: () => {
        return editDataService
          .getPayorders()
          .then(response => {
            let json = response.json();
            json = json.map(function (item) {
              item.link = "/payOrders/"+item.fileName;
              return item;
            });
            return {
              data: json,
              totalCount: json.length
            }
          })
          .catch(error => {
            let json = error.json();
            toastr.error(json.message);
            return {
              data: {},
              totalCount: 0
            }
          });
      },

    /*  insert: data => {
        return editDataService
          .sendNewFiliation(data)
          .then(function (response) {
            return response.json();
          })
          .catch(error => {
            let json = error.json();
            toastr.error(json.message);
            return {};
          });
      },

      update: function (oldData, newData) {
        newData["id"] = oldData.id;
        return editDataService
          .sendFiliation(newData)
          .then(function (response) {
            return response.json();
          })
          .catch(error => {
            let json = error.json();
            toastr.error(json.message);
            return {};
          });
      },*/

      remove: function (item) {
        return editDataService
          .sendRemovePayorder(item)
          .then(function (response) {
            return response.json();
          })
          .catch(error => {
            let json = error.json();
            toastr.error(json.message);
            return {};
          });
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/payorder/payorder.component.ts